<div class="d-flex px-2 align-items-center border-right">
  <input
    [(ngModel)]="queueRequests"
    id="enable-request-queueing"
    type="checkbox"
    (change)="onChange()"
    class="mx-1 my-1"
    data-testid="request-queueing-test-queue-requests-checkbox">
  <label for="enable-request-queueing nowrap" class="mx-1 my-1">
    Test Request Queue
  </label>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/header/request-queueing-test/request-queueing-test.component.html